import React from 'react';

/** Always render exactly 3 lines so broker table rows share the same height. */
export function ThreeLineStack({
  lines,
  mutedColor,
}: {
  lines: [React.ReactNode, React.ReactNode?, React.ReactNode?];
  mutedColor?: string;
}): React.ReactElement {
  const [a, b, c] = lines;
  const cells = [a, b, c];
  return (
    <div className="broker-3line-stack">
      {cells.map((line, i) => {
        const empty = line == null || line === '';
        return (
          <div
            key={i}
            className={i === 0 ? 'broker-3line-line' : 'broker-3line-line broker-3line-line--sub'}
            style={i > 0 && mutedColor && !empty ? { color: mutedColor } : undefined}
            // \ud3ed \uc81c\ud55c\uc73c\ub85c "..." \uc904\uc784 \ucc98\ub9ac\ub420 \ub54c \ub9c8\uc6b0\uc2a4\uc624\ubc84\ub85c \uc804\uccb4 \ud14d\uc2a4\ud2b8\ub97c \ubcf4\uac8c \ud55c\ub2e4.
            // JSX(\uc0c9\uce60\ub41c span \ub4f1)\ub294 title \ub85c \ubabb \ub123\uc73c\ub2c8 \ubb38\uc790\uc5f4\uc77c \ub54c\ub9cc \ub2e8\ub2e4.
            title={typeof line === 'string' ? line : undefined}
          >
            {empty ? '\u00a0' : line}
          </div>
        );
      })}
    </div>
  );
}
